module.exports = __webpack_public_path__ + "static/media/lato-v15-latin-regular.056a373d.eot";